import React from 'react';
import { withRouter } from 'inferno-router';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  ScrollView,
} from './components/base_components';
import { BusyComponent, BusyOverlay } from './components/busy_component';
import ProgressSpinner from './components/progress_spinner';
import TextButton from './components/buttons/text_button';
import VolumeSelect from './components/volume_select';

import UserAdminStore from './stores/user_admin_store';

const styles = StyleSheet.create({
  orgUserEditScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '3em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    marginTop: '0.5em',
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  add: {
    marginTop: '1em',
  },
  text: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  itemLine: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    flexDirection: 'row',
  },
  value: {
    width: '20em',
  },
  itemButton: {
    height: '2em',
  },
  addVolume: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
  },
  button: {
    marginTop: '1em',
    height: '3em',
  },
  orgSelect: {
    marginBottom: '0.5em',
    marginTop: '0.5em',
  },
  input: {
    marginTop: '0.5em',
    width: '25em',
    height: '3em',
    paddingLeft: '1em',
    color: 'black',
    backgroundColor: '#ccc',
    borderRadius: '0.5em',
  },
  label: {
    marginTop: '0.5em',
  },
});

type Props = {
  match: any;
};
type State = {
  org_id: number;
  user_id: number;
  user: any;
  add_volume_id: string;
  device_name: string;
};

export default class OrgUserEditScreen extends BusyComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    const org_id = parseInt(this.props.match.params.org_id);
    const user_id = parseInt(this.props.match.params.user_id);
    this.state = {
      org_id,
      user_id,
      user: null,
      device_name: '',
      add_volume_id: '',
      new_password: '',
    };
  }
  componentDidMount() {
    const { user_id } = this.state;
    UserAdminStore.addChangeListener(this._onUserUpdate);
    UserAdminStore.fetchUser(user_id);
    this._onUserUpdate();
  }
  componentWillUnmount() {
    UserAdminStore.removeChangeListener(this._onUserUpdate);
  }
  _onUserUpdate = () => {
    const { user_id } = this.state;
    const user = UserAdminStore.getUser(user_id);
    this.setState({ user });
  };
  _onVolumeChange = (add_volume_id) => this.setState({ add_volume_id });
  _onAddVolumePress = () => {
    const { user_id, add_volume_id } = this.state;
    if (add_volume_id && this.setBusy()) {
      const opts = { user_id, volume_id: add_volume_id };
      UserAdminStore.addVolume(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to add volume, err:' + err);
        }
      });
    }
  };
  _onVolumeDelete = (volume) => {
    if (this.setBusy()) {
      const { user_id } = this.state;
      const opts = { user_id, volume_id: volume.volume_id };
      UserAdminStore.deleteVolume(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to remove volume, err:' + err);
        }
      });
    }
  };
  _onOrgDelete = (org) => {
    if (this.setBusy()) {
      const { user_id } = this.state;
      const opts = { user_id, org_id: org.org_id };
      UserAdminStore.deleteOrg(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to remove oeg, err:' + err);
        }
      });
    }
  };
  _onAddDevicePress = () => {
    const { user_id, org_id, device_name } = this.state;
    if (device_name && this.setBusy()) {
      const opts = { user_id, org_id, device_name };
      UserAdminStore.addDevice(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Failed to add device, err:' + err);
        }
      });
    }
  };
  _onChangePasswordPress = () => {
    const { user_id, new_password } = this.state;
    if (new_password && this.setBusy()) {
      const opts = { user_id, password: new_password };
      UserAdminStore.updateUser(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Password change failed: ' + err);
        } else {
          this.setState({ new_password: '' });
        }
      });
    }
  };
  _orgFilter = (obj) => {
    const { org_id } = this.state;
    return obj.org_id === org_id;
  };

  render() {
    const {
      org_id,
      user,
      add_volume_id,
      device_name,
      new_password,
    } = this.state;

    let content = null;
    if (!user) {
      content = <ProgressSpinner />;
    } else {
      const { user_name, volume_list, device_list } = user;

      const volumes = volume_list
        .filter(this._orgFilter)
        .map((volume, i) => (
          <Volume key={i} volume={volume} onDelete={this._onVolumeDelete} />
        ));
      const devices = device_list
        .filter(this._orgFilter)
        .map((device, i) => <Device key={i} device={device} />);

      content = (
        <>
          <Text style={styles.text}>User: {user_name}</Text>
          <Line />
          <Text style={styles.text}>Volumes:</Text>
          {volumes}
          <Text style={styles.text}>Add Volume:</Text>
          <VolumeSelect
            style={styles.addVolume}
            excludeList={volume_list}
            onlyOrgId={org_id}
            excludeDisabled={true}
            user={user}
            value={add_volume_id}
            onChange={this._onVolumeChange}
          />
          <TextButton
            style={styles.button}
            text='Add Volume'
            onPress={this._onAddVolumePress}
          />
          <Line />
          <Text style={styles.text}>Devices:</Text>
          {devices}
          <Text style={styles.text}>New Device:</Text>
          <TextInput
            style={styles.input}
            placeholder='Device Name'
            value={device_name}
            onChangeText={(device_name) => this.setState({ device_name })}
          />
          <TextButton
            style={styles.button}
            text='Add Device'
            onPress={this._onAddDevicePress}
          />
          <Line />
          <Text style={styles.text}>Update User:</Text>
          <TextInput
            style={styles.input}
            placeholder='New Password'
            value={new_password}
            onChangeText={(new_password) => this.setState({ new_password })}
          />
          <TextButton
            style={styles.button}
            text='Change Password'
            onPress={this._onChangePasswordPress}
          />
          <Line />
        </>
      );
    }
    return (
      <View style={styles.orgUserEditScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Text style={styles.headerText}>MONP ABT</Text>
          <Line />
          {content}
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Line() {
  return <View style={styles.line} />;
}
function ItemLine(props) {
  const { value, onPress } = props;
  const buttonText = props.buttonText || 'delete';

  return (
    <View style={styles.itemLine}>
      <Text style={styles.value}>{value}</Text>
      <TextButton
        style={styles.itemButton}
        text={buttonText}
        onPress={onPress}
      />
    </View>
  );
}
function Volume(props) {
  const { volume, onDelete } = props;
  function _onDelete() {
    onDelete(volume);
  }
  return <ItemLine value={volume.volume_name} onPress={_onDelete} />;
}
const Device = withRouter((props) => {
  const { device } = props;
  function _onPress() {
    props.history.push(`/admin/device/${device.device_id}`);
  }
  return (
    <ItemLine value={device.device_name} buttonText='edit' onPress={_onPress} />
  );
});
